module.exports = __webpack_public_path__ + "static/media/texture (31).6af72467.jpg";